import { render, staticRenderFns } from "./MealConsumptionDetail.vue?vue&type=template&id=6e6f1b09"
import script from "./MealConsumptionDetail.vue?vue&type=script&lang=js"
export * from "./MealConsumptionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports